import { Component, OnDestroy, OnInit, inject } from "@angular/core";
import { Router } from "@angular/router";

import { UserBriefingModel } from "../../models/user-briefing-model.service";
import { Subject } from "rxjs";
import { map, takeUntil } from "rxjs/operators";
import { BriefingFilterService } from "../../util/briefing-filter.service";
import { FilterPageOptionEnum } from "app/shared/enums";

@Component({
	selector: "ic-briefing",
	templateUrl: "./user-briefing.component.html",
	styleUrls: ["./user-briefing.component.scss"],
	providers: [BriefingFilterService, UserBriefingModel],
	standalone: false,
})
export class UserBriefingComponent implements OnInit, OnDestroy {
	private readonly briefingModel = inject(UserBriefingModel);
	private readonly router = inject(Router);

	pageOption = FilterPageOptionEnum.USER_BRIEFING;
	private readonly destroy$ = new Subject<void>();

	briefing$ = this.briefingModel.filteredBriefingHistory$;
	loading$ = this.briefingModel.loading$;
	hasActiveFilters$ = this.briefingModel.filter$.pipe(map((filters) => !!filters.length));

	ngOnInit() {
		this.briefingModel.selectFilter(this.pageOption);
		this.briefingModel.loadUserBriefing().pipe(takeUntil(this.destroy$)).subscribe();
	}

	search(search: string) {
		this.briefingModel.search(search);
	}

	confirm() {
		this.briefingModel.confirmBriefing().subscribe();
		this.close();
	}

	close() {
		this.router.navigate(["/home"]);
	}

	ngOnDestroy() {
		this.destroy$.next();
		this.destroy$.complete();
	}
}
